
import { useSelector } from 'react-redux';
import useCurrent from './useCurrent';
import { useEffect } from 'react';
import i18next from 'i18next';

const useInvoice = () => {
    const {currentLangId,currentCompany} = useCurrent();
    const settings = useSelector(state => state.settings)
    const SETTING_INVOICE = settings?.invoiceSettings;
    const SETTING_QUOTE = settings?.quoteSettings;

    // Initalize the product items list
    const initalProductItem = Array.from(Array(parseInt( SETTING_INVOICE?.INV_ITEMS_ROW_NUMBER) || 10),(e,index)=>{
        return {
            index:index,
            productId:'', 
            productName:'',
            productDesc:'',
            qty:'',
            qtyDays:'',
            price:'',
            priceUnit:'',
            productDiscount:'',
            productNetTotal:'',
            productVat:'',
            productNetTotalWithVat:'',
        }
    });

    const toFloat = (valueString,toFixed=true) => {
        if(!SETTING_INVOICE) return 
        const tryToFloat = parseFloat(valueString)
        if(!isNaN(tryToFloat)){
            if( tryToFloat && toFixed ){
                return  tryToFloat.toFixed(SETTING_INVOICE.INV_TO_FIXED_NUMBER)
            }else if( tryToFloat && !toFixed ){
                return  tryToFloat
            }
        }
        return 0;
        
    }
    // Calculate the sum price of the product list
    const calcSumPrice = (productList) => {
        const totalAmount = productList.reduce((accumulatar ,obj) => {
            if( obj !== undefined && obj.price !== undefined && obj.price != null && !isNaN(obj?.price) )
                return  ( toFloat(accumulatar,false) + toFloat( obj?.price,false) )
            else
                return toFloat(accumulatar,false)
        
            },0);
        return toFloat(totalAmount,false);
    }
    // Calculate the total price of the product list
    const calcSumNetTotal = (productList) => {
        if(productList){
        const totalAmount = productList.reduce((accumulatar ,obj) => {
            if( obj !== undefined && obj.productNetTotal !== undefined && obj.productNetTotal != null && !isNaN(obj?.productNetTotal) )
                return  ( toFloat(accumulatar,false) + toFloat( obj?.productNetTotal,false) )
            else
                return toFloat(accumulatar,false)
        
            },0);
        return toFloat(totalAmount,false);
        }
    }

    const calcVat = (amountValue) => {
        if(!SETTING_INVOICE) return 
        let amountWithVat = 0 ;
        // if(SETTING_INVOICE.PRICE_INCLUDE_VAT === 'true'){
        //     amountWithVat = amountValue * (parseFloat(SETTING_INVOICE.INV_VAT_PERCENT)/toFloat(`1${SETTING_INVOICE.INV_VAT_PERCENT}`,false))
        // }else{
            amountWithVat = amountValue * (parseFloat(SETTING_INVOICE.INV_VAT_PERCENT)/100)

       // }
        return amountWithVat;
    }
    
    useEffect(()=>{
        
    },[])
    
    
    let currency;
    if (currentCompany?.currency) {
      // Trim whitespace and make sure we have a valid currency code
      const companyCurrentcy = currentCompany.currency.trim();
      // If it's "R" (South African Rand), convert to proper ISO code "ZAR"
      currency = companyCurrentcy === "R" ? "SAR" : companyCurrentcy;
      // Ensure it's at least 3 characters (ISO standard)
      if (currency.length < 3) {
        currency = SETTING_INVOICE?.INV_CURRENCY || 'SAR';
      }
    } else {
      currency = SETTING_INVOICE?.INV_CURRENCY || 'SAR';
    }
    
    // Create the formatter with the processed currency code
    const formatter = new Intl.NumberFormat(`${currentLangId || 'en'}-US`, {
      style: 'currency',
      currency: currency
    });

    // New function to add to InvListBasic component
const formatAmount = (amount, currencyInfo) => {
    // If we have currency info from API, prioritize it
    if (currencyInfo) {
      // Get the currency code (and trim any whitespace)
      const currencyCode = currencyInfo.currency_code?.trim() || 'SAR';
      
      // Create a formatter with this specific currency
      const itemFormatter = new Intl.NumberFormat(i18next.language, {
        style: 'currency',
        currency: currencyCode.toUpperCase()
      });
      
      return itemFormatter.format(amount);
    }
    
    // Fall back to the default formatter if no currency info
    return formatter.format(amount);
  };


  


    return {
        SETTING_INVOICE,
        SETTING_QUOTE,
        initalProductItem,
        calcSumPrice,
        calcSumNetTotal,
        toFloat,
        calcVat,
        formatter,
        formatAmount
    }

}

export default useInvoice
